module.exports = __webpack_public_path__ + "static/image-classifier-demo-50b99032853ec786c843119af25da282.jpg";